import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CalendarPlus, MessageSquareText, UserRoundPlus, UsersRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { selectUnreadCount } from "../../../notifications/redux/notificationsSelectors";
import "./QuickActions.css";

export default function QuickActions({ onNewAppointment }) {
  const navigate = useNavigate();
  const { t } = useTranslation("cabinetDashboard");
  const unreadCount = useSelector(selectUnreadCount);

  const actions = [
    {
      id: "appointment",
      label: t("dashboard.quickActions.newAppointment"),
      icon: <CalendarPlus aria-hidden="true" />,
      onClick: onNewAppointment,
    },
    {
      id: "new-patient",
      label: t("dashboard.quickActions.newPatient"),
      icon: <UserRoundPlus aria-hidden="true" />,
      path: "/patients",
    },
    {
      id: "messages",
      label: t("dashboard.quickActions.messages"),
      icon: <MessageSquareText aria-hidden="true" />,
      path: "/messages",
      badge: unreadCount,
    },
    {
      id: "waiting-room",
      label: t("dashboard.quickActions.waitingRoom"),
      icon: <UsersRound aria-hidden="true" />,
      path: "/waiting-room",
    },
  ];

  return (
    <nav className="qa" aria-label={t("dashboard.quickActions.title")}>
      <h2 className="qa__title">{t("dashboard.quickActions.title")}</h2>
      <div className="qa__list">
        {actions.map((action) => (
          <button
            type="button"
            key={action.id}
            className="qa__btn"
            onClick={() => action.onClick ? action.onClick() : navigate(action.path)}
          >
            <span className="qa__icon">{action.icon}</span>
            <span className="qa__label">{action.label}</span>
            {action.badge > 0 && (
              <span className="qa__badge" aria-label={`${action.badge} ${t("dashboard.quickActions.unread")}`}>
                {action.badge > 99 ? "99+" : action.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
}
